// Configuration pour l'optimisation des coûts des APIs de calcul d'itinéraires

export const OPTIMIZATION_CONFIG = {
  // Utilisation d'OpenRouteService (gratuit)
  USE_OPENROUTE_SERVICE: process.env.REACT_APP_USE_HYBRID_ROUTING !== 'false',
  
  // Désactiver Google Directions par défaut (ne basculera pas sur Google)
  ENABLE_GOOGLE_DIRECTIONS: process.env.REACT_APP_ENABLE_GOOGLE_DIRECTIONS === 'true',
  
  // Durée du cache en heures
  CACHE_EXPIRATION_HOURS: parseInt(process.env.REACT_APP_CACHE_EXPIRATION_HOURS) || 24,
  
  // Distance critique en km (utilise Google Maps au-delà)
  CRITICAL_DISTANCE_KM: parseInt(process.env.REACT_APP_CRITICAL_DISTANCE_KM) || 20,
  
  // Vitesse moyenne en ville (km/h)
  AVERAGE_SPEED_KMH: 30,
  
  // Tolérance pour les coordonnées du Moulin (en degrés)
  MOULIN_COORDINATES_TOLERANCE: 0.001, // ~100m
  
  // Limites d'utilisation
  LIMITS: {
    OPENROUTE_SERVICE_DAILY: 2000, // requêtes/jour gratuites
    OPENROUTE_SERVICE_MINUTE: 40, // requêtes/minute
    GOOGLE_MAPS_DAILY: 100000, // selon votre quota
  },
  
  // Seuils d'alerte
  ALERTS: {
    OPENROUTE_SERVICE_WARNING: 1800, // 90% de la limite quotidienne
    OPENROUTE_SERVICE_MINUTE_WARNING: 35, // 87.5% de la limite minute
    GOOGLE_MAPS_WARNING: 80000, // 80% de la limite
  }
};

// Messages d'information
export const MESSAGES = {
  CACHE_HIT: 'Résultat trouvé en cache',
  USING_OPENROUTE: 'Utilisation d\'OpenRouteService (gratuit)',
  USING_GOOGLE_MAPS: 'Utilisation de Google Maps (calcul critique)',
  USING_APPROXIMATE: 'Utilisation de calculs approximatifs (fallback)'
};
